// extracted by mini-css-extract-plugin
module.exports = {"i3evaga":"i3evaga"};